/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2018 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import ChildComponent from '../../../Utility/Component/ChildComponent';
import ISymbolData from '../../ISymbolData';
import StreakTrackerRuleBase from '../StreakTrackerRuleBase';

/** Base class for creating [[StreakTracker]] filter. */
@cc._decorator.ccclass
export default abstract class StreakTrackerFilterBase extends ChildComponent<StreakTrackerRuleBase>
{
    /**
     * Filters symbols based on criteria.
     * @param symbols Symbols to filter.
     * @returns Symbols matching criteria.
     */
    public abstract Filter: (symbols: ISymbolData[]) => ISymbolData[];
}
